/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  const target = event.target.closest(
    '[data-toggle-target], [data-tab-target], [data-modal-target], [data-toggle-reset], [data-close-outside]'
  );
  if (!target) return;

  if (target.dataset.toggleTarget) {
    slideToggle(event);
  }

  if (target.dataset.tabTarget) {
    tabToggle(event);
  }

  if (target.dataset.modalTarget) {
    modalPop(target.dataset.modalTarget);
  }

  if (target.hasAttribute('data-toggle-reset')) {
    console.log('Resetting toggles...');
    document
      .querySelectorAll('[data-toggle-target]')
      .forEach((toggle) => toggle.classList.remove('active'));
    document.querySelectorAll('[data-toggle-content]').forEach((content) => {
      content.classList.remove('active');
      setTimeout(() => (content.style.height = '0px'), 500);
    });
  }

  if (target.hasAttribute('data-close-outside')) {
    const parent = target.closest('[data-toggle-content]');
    if (parent) {
      const toggleTargetName = parent.dataset.toggleContent;
      parent.classList.remove('active');
      document
        .querySelector(`[data-toggle-target="${toggleTargetName}"]`)
        ?.classList.remove('active');
    }
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const closeItems = document.querySelectorAll('[data-close-outside]');
    closeItems.forEach((item) => {
      parent = item.closest('[data-toggle-content]');
      toggleTargetName = parent.dataset.toggleContent;
      parent.classList.remove('active');
      document
        .querySelector(`[data-toggle-target="${toggleTargetName}"]`)
        .classList.remove('active');
    });

    //console.log('Escape key pressed');
  }
});

/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  event.preventDefault();
  console.log('slide down toggle');

  const target = event.target.dataset.toggleTarget;
  if (!target) return;

  const toggles = document.querySelectorAll(`[data-toggle-target="${target}"]`);
  const toggleContainers = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );

  // Reset all items if `data-reset` is present
  if (event.target.hasAttribute('data-reset')) {
    document
      .querySelectorAll('[data-toggle-target]')
      .forEach((toggle) => toggle.classList.remove('active'));
    document.querySelectorAll('[data-toggle-content]').forEach((content) => {
      content.classList.remove('active');
      setTimeout(() => (content.style.height = '0px'), 500);
    });
  }

  toggleContainers.forEach((container) => {
    const isActive = container.classList.contains('active');

    if (!isActive) {
      // Activate targeted elements
      toggles.forEach((toggle) => toggle.classList.add('active'));
      container.classList.add('active');

      // Animate height expansion
      container.style.height = 'auto';
      const height = container.offsetHeight + 'px';
      container.style.height = '0px';

      setTimeout(() => (container.style.height = height), 0);

      container.addEventListener(
        'transitionend',
        () => {
          container.style.height = 'auto';
        },
        { once: true }
      );
    } else {
      // Deactivate elements
      toggles.forEach((toggle) => toggle.classList.remove('active'));

      // Animate height collapse
      container.style.height = 'auto';
      const height = container.offsetHeight + 'px';
      container.style.height = height;

      setTimeout(() => {
        container.classList.remove('active');
        container.style.height = '0px';
      }, 0);

      container.addEventListener(
        'transitionend',
        () => {
          container.style.height = '0px';
        },
        { once: true }
      );
    }
  });
}

/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();
  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
  tabGroups.forEach((group) => {
    group.classList.remove('active');
  });
  event.target.classList.add('active');
  document
    .querySelectorAll(
      `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
    )
    .forEach((group) => {
      group.classList.add('active');
    });
}

// MODAL TOGGLING
function modalPop(target) {
  console.log(target, 'ModalTarget');
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  );
  const modalSlider = modalContent.querySelector('.bd-slider')
    ? modalContent.querySelector('.bd-slider')
    : '';
  if (!modalContent) return console.error('Modal not found!');

  // Call repositionModal before displaying the modal

  if (modalContent.hasAttribute('data-reposition')) {
    // Store original parent before modifying position
    modalContent.dataset.originalParent = modalContent.parentNode;

    repositionModal(modalContent);
    document.querySelector('body').classList.add('overflow-hidden');
  }

  modalContent.classList.add('active');
  document.body.classList.add('overflow-hidden');

  modalContent
    .querySelectorAll('[data-close]')
    .forEach((btn) =>
      btn.addEventListener('click', () => closeModal(modalContent))
    );

  window.onclick = (event) => {
    if (event.target === modalContent) closeModal(modalContent);
  };

  window.addEventListener('keyup', (e) => {
    if (e.code === 'Escape') closeModal(modalContent);
  });

  if (modalSlider) {
    // Do stuff later if there is a slider in the modal
  }

  /* STUFF FOR PRODUCT QUOTE */
  const productContainer = modalContent.closest('[data-product-item]');
  const quoteContainer = modalContent.closest('[data-quote-item]');
  const quoteHeader = modalContent.querySelector('[data-default-title]')
    ? modalContent.querySelector('[data-default-title]')
    : null;
  if (productContainer) {
    console.log('product-container', productContainer);
    const productTitle = productContainer.dataset.productTitle;
    const productImage = productContainer.querySelector('img');
    if (productImage) {
      modalContent.classList.add('with-image');
      console.log('with-image');
      localStorage.setItem('quoteProduct', productTitle);
      localStorage.setItem('quoteImageSrc', productImage.src);
      localStorage.setItem('quoteImageSrcset', productImage.srcset);
      quoteHeader ? (quoteHeader.innerHTML = 'Request Quote for the') : null;
      modalContent.querySelector('[data-product-image] img').src =
        productImage.src;
      modalContent.querySelector('[data-product-image] img').srcset =
        productImage.srcset;
      modalContent.querySelector('[data-product-title]').value = productTitle;
      modalContent.querySelector('[data-quote-display-title]').innerHTML =
        productTitle;
    } else {
      console.log('without-image');
      quoteHeader
        ? (quoteHeader.innerHTML = 'Request a Quote/Contact Us')
        : null;
    }
  }
  if (quoteContainer) {
    console.log('non-product quote');
    modalContent.classList.add('general-quote');
    quoteHeader ? (quoteHeader.innerHTML = 'Request a Quote/Contact Us') : null;
  }

  /* END STUFF FOR PRODUCT QUOTE */
}

function stopVideos() {
  document.querySelectorAll('iframe').forEach((v) => {
    v.src = v.src;
  });
  document.querySelectorAll('video').forEach((v) => {
    v.pause();
  });
}

function closeModal(modal) {
  modal.classList.remove('active');
  document.querySelector('body').classList.remove('overflow-hidden');
  const cookie = modal.dataset.cookieModal ? modal.dataset.cookieModal : false;
  const days = modal.dataset.cookieExpires ? modal.dataset.cookieExpires : 5;
  if (cookie) {
    setCookie(cookie, 'seen', days);
  }
  stopVideos();
  restoreElement(modal);

  /* STUFF FOR PRODUCT QUOTE */
  localStorage.removeItem('quoteProduct');
  localStorage.removeItem('quoteImageSrc');
  localStorage.removeItem('quoteImageSrcset');
  modal.classList.remove('with-image');
  modal.querySelector('[data-product-image] img').src = '';
  modal.querySelector('[data-product-image] img').srcset = '';
  modal.querySelector('[data-product-title]').value = '';
  modal.querySelector('[data-quote-display-title]').innerHTML = '';
}

function repositionModal(elementToMove) {
  document.body.insertBefore(elementToMove, document.body.firstChild);
}

// To restore the element to its original position
function restoreElement(elementToMove) {
  const originalParent = elementToMove.originalParent; // Retrieve the stored reference

  if (!originalParent || !(originalParent instanceof HTMLElement)) {
    console.error('Original parent not found or is invalid!');
    return;
  }

  const originalNextSibling = elementToMove.nextSibling;

  // Restore to original position
  if (originalNextSibling) {
    originalParent.insertBefore(elementToMove, originalNextSibling);
  } else {
    originalParent.appendChild(elementToMove);
  }
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}
